import React from 'react';

export interface PlayerStatusProps {
  playerName: string;
  characterName?: string;
  currentScene?: string;
  inventory?: string[];
  stats?: Record<string, any>;
  isOnline?: boolean;
  className?: string;
}

const PlayerStatus: React.FC<PlayerStatusProps> = ({
  playerName,
  characterName,
  currentScene,
  inventory = [],
  stats = {},
  isOnline = true,
  className = ''
}) => {
  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-4 ${className}`}>
      {/* Player Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
            <span className="text-white font-medium text-sm">
              {playerName.charAt(0).toUpperCase()}
            </span>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">{playerName}</h3>
            {characterName && (
              <p className="text-sm text-gray-600">{characterName}</p>
            )}
          </div>
        </div>
        
        {/* Online Status */}
        <div className="flex items-center space-x-2">
          <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-500' : 'bg-gray-400'}`}></div>
          <span className="text-xs text-gray-500">
            {isOnline ? 'Online' : 'Offline'}
          </span>
        </div>
      </div>
      
      {/* Current Scene */}
      {currentScene && (
        <div className="mb-4">
          <h4 className="text-sm font-medium text-gray-700 mb-1">Current Scene</h4>
          <p className="text-sm text-gray-600 bg-gray-50 rounded px-3 py-2">
            {currentScene}
          </p>
        </div>
      )}
      
      {/* Inventory */}
      {inventory.length > 0 && (
        <div className="mb-4">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Inventory</h4>
          <div className="flex flex-wrap gap-2">
            {inventory.map((item, index) => (
              <span
                key={index}
                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      )}
      
      {/* Stats */}
      {Object.keys(stats).length > 0 && (
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-2">Stats</h4>
          <div className="space-y-2">
            {Object.entries(stats).map(([key, value]) => (
              <div key={key} className="flex justify-between items-center">
                <span className="text-sm text-gray-600 capitalize">
                  {key.replace(/([A-Z])/g, ' $1').trim()}
                </span>
                <span className="text-sm font-medium text-gray-900">
                  {typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PlayerStatus;
